import * as React from 'react'
// components
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import LearningManagementSection from '../components/sections/LearningManagement'

const LearningManagement = () => {
  return (
    <>
      <div id='smooth-wrapper'>
        <div id='smooth-content'>
          <div className='podio'>
            <LearningManagementSection />
            <Footer />
          </div>
        </div>
      </div>
      <Header />
    </>
  )
}

export default LearningManagement
